import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import About from "../About/About";
import Projects from "../Projects/Projects";
import OurTeam from "../our-team/OurTeam";
import Contact from "../Contact/Contact";
import Fotter from "../Fotter/Fotter";

const Hero = () => {
  return (
    <>
        <section className="bg-white pt-40">
      <div className="py-8 px-4 mx-auto max-w-screen-xl text-center lg:py-16 lg:px-12">
        
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <Link
            to={'/news'}
            className="inline-flex justify-between items-center py-1 font-sans px-1 pr-4 mb-7 text-sm text-gray-700 bg-gray-100 rounded-full dark:text-white hover:bg-[#b1c6da]"
            role="alert"
          >
            <span className="text-xs bg-[#2766be] rounded-full text-white px-4 py-1.5 mr-3">Yangliklar</span>
            <span className="text-sm font-medium">Nima yangiliklar borligini ko'ring</span>
            <svg className="ml-2 w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd"></path></svg>
          </Link>
        </motion.div>

        <motion.h1
          className="mb-4 text-4xl font-extrabold tracking-tight leading-none text-gray-900 md:text-5xl lg:text-6xl"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.3, duration: 1 }}
        >
          EvoTeam - Kelajakni yaratamiz
        </motion.h1>

        <motion.p
          className="mb-8 text-lg font-normal text-[#8c9aa9] lg:text-xl sm:px-16 xl:px-48 dark:text-gray-400"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 1 }}
        >
          Bizning eng so'nggi loyihalarimizni ko'rib chiqing IT va BIZNES dunyosidagi o'zgarishlarni kuzating
        </motion.p>

        <motion.div
          className="flex flex-col mb-8 lg:mb-16 space-y-4 sm:flex-row sm:justify-center sm:space-y-0 sm:space-x-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.9, duration: 1 }}
        >
          <Link
            to={'/biz-haqimizda'}
            className="inline-flex justify-center items-center py-3 px-5 text-base font-medium text-center rounded-lg bg-[#2766be] text-white hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 dark:focus:ring-primary-900 font-sans"
          >
            Biz haqimizda
            <svg className="ml-2 -mr-1 w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
          </Link>
          <Link
            to="#"
            className="inline-flex justify-center items-center py-3 px-5 text-base font-medium text-center text-gray-900 rounded-lg border border-gray-300 hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 dark:text-white dark:border-gray-700 dark:hover:bg-gray-700 dark:focus:ring-gray-800 font-sans"
          >
            <svg className="mr-2 -ml-1 w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path d="M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z"></path></svg>
            Videoni Ko'rish
          </Link>
        </motion.div>
      </div>
    </section>
    <About />
    <Projects />
    <OurTeam />
    <Contact />
    <Fotter />
    </>
  );
};

export default Hero;
